import { createSuccessAction } from '../../redux-util/async-helpers';
import { LIST_ALL_USERS, LIST_ADOPTION_USERS } from '../bridge-method-remap';

const actions = [LIST_ALL_USERS, LIST_ADOPTION_USERS];

const successes = actions.map(a => createSuccessAction(a).type);

export default function(state = {}, action) {
  if (successes.indexOf(action.type) !== -1) {
    const newState = { ...state };
    action.data.users
      // Sometimes bridge gives us users with no id. They should fix this, but let's not crash the page if it happens.
      .filter(u => !!u.id)
      .forEach(d => {
        newState[d.id] = d;
      });
    return newState;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/users/reducer.js